import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

console.log('🌟 [MAIN] Frontend application starting...', {
  timestamp: new Date().toISOString(),
  url: window.location.href,
  userAgent: navigator.userAgent,
  environment: import.meta.env.MODE,
  production: import.meta.env.PROD,
  apiUrl: import.meta.env.VITE_API_URL || 'NOT_SET',
  version: '1.0.1'
})

// Add global error handler
window.addEventListener('error', (event) => {
  console.error('🚨 [GLOBAL] Unhandled error:', {
    timestamp: new Date().toISOString(),
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error
  })
})

window.addEventListener('unhandledrejection', (event) => {
  console.error('🚨 [GLOBAL] Unhandled promise rejection:', {
    timestamp: new Date().toISOString(),
    reason: event.reason,
    promise: event.promise
  })
})

console.log('🎯 [MAIN] Mounting React application...', {
  timestamp: new Date().toISOString()
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

console.log('✅ [MAIN] React application mounted successfully', {
  timestamp: new Date().toISOString()
})